//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllAgentLeadDisabledCarriers(v: string, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentLeadDisabledCarriersSearchResponse> {
        let url_ = this.baseUrl + "/api/lead/v{v}/agentleaddisabledcarrier?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllAgentLeadDisabledCarriers(_response);
        });
    }

    protected processGetAllAgentLeadDisabledCarriers(response: Response): Promise<AgentLeadDisabledCarriersSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentLeadDisabledCarriersSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentLeadDisabledCarriersSearchResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    addAgentLeadDisabledCarrier(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: AgentLeadDisabledCarrierModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/lead/v{v}/agentleaddisabledcarrier";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processAddAgentLeadDisabledCarrier(_response);
        });
    }

    protected processAddAgentLeadDisabledCarrier(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateAgentLeadDisabledCarrier(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: AgentLeadDisabledCarrierModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/lead/v{v}/agentleaddisabledcarrier";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateAgentLeadDisabledCarrier(_response);
        });
    }

    protected processUpdateAgentLeadDisabledCarrier(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAgentLeadDisabledCarrierCompanyName(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentLeadDisabledCarrierModel> {
        let url_ = this.baseUrl + "/api/lead/v{v}/agentleaddisabledcarrier/GetAgentLeadDisabledCarrierCompanyName";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentLeadDisabledCarrierCompanyName(_response);
        });
    }

    protected processGetAgentLeadDisabledCarrierCompanyName(response: Response): Promise<AgentLeadDisabledCarrierModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentLeadDisabledCarrierModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentLeadDisabledCarrierModel>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    deleteAgentLeadDisabledCarrier(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/lead/v{v}/agentleaddisabledcarrier/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDeleteAgentLeadDisabledCarrier(_response);
        });
    }

    protected processDeleteAgentLeadDisabledCarrier(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param carrierId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    isCarrierDisabledForAgentLead(v: string, carrierId?: number | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/lead/v{v}/agentleaddisabledcarrier/isdisabled?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (carrierId === null)
            throw new Error("The parameter 'carrierId' cannot be null.");
        else if (carrierId !== undefined)
            url_ += "carrierId=" + encodeURIComponent("" + carrierId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processIsCarrierDisabledForAgentLead(_response);
        });
    }

    protected processIsCarrierDisabledForAgentLead(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getReportLeadSourceLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/lead/v{v}/leads/reportleadsourcelookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetReportLeadSourceLookup(_response);
        });
    }

    protected processGetReportLeadSourceLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param isContracted (optional) 
     * @param agentLeadId (optional) 
     * @param agentId (optional) 
     * @param agentLastName (optional) 
     * @param assigneeId (optional) 
     * @param subAssigneeId (optional) 
     * @param agentLeadSourceId (optional) 
     * @param productLineId (optional) 
     * @param carrierId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param leadPhaseId (optional) 
     * @param leadPhaseDetailId (optional) 
     * @param status (optional) 
     * @param stage (optional) 
     * @param isIncludeInactiveCarrier (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllMarketerLeads(v: string, isContracted?: boolean | undefined, agentLeadId?: number | null | undefined, agentId?: number | null | undefined, agentLastName?: string | null | undefined, assigneeId?: number | null | undefined, subAssigneeId?: number | null | undefined, agentLeadSourceId?: number | null | undefined, productLineId?: number | null | undefined, carrierId?: number | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, leadPhaseId?: number | null | undefined, leadPhaseDetailId?: number | null | undefined, status?: number | null | undefined, stage?: number | null | undefined, isIncludeInactiveCarrier?: boolean | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<MarketerLeadSearchReponse> {
        let url_ = this.baseUrl + "/api/lead/v{v}/marketerleads?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (isContracted === null)
            throw new Error("The parameter 'isContracted' cannot be null.");
        else if (isContracted !== undefined)
            url_ += "IsContracted=" + encodeURIComponent("" + isContracted) + "&";
        if (agentLeadId !== undefined && agentLeadId !== null)
            url_ += "AgentLeadId=" + encodeURIComponent("" + agentLeadId) + "&";
        if (agentId !== undefined && agentId !== null)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (agentLastName !== undefined && agentLastName !== null)
            url_ += "AgentLastName=" + encodeURIComponent("" + agentLastName) + "&";
        if (assigneeId !== undefined && assigneeId !== null)
            url_ += "AssigneeId=" + encodeURIComponent("" + assigneeId) + "&";
        if (subAssigneeId !== undefined && subAssigneeId !== null)
            url_ += "SubAssigneeId=" + encodeURIComponent("" + subAssigneeId) + "&";
        if (agentLeadSourceId !== undefined && agentLeadSourceId !== null)
            url_ += "AgentLeadSourceId=" + encodeURIComponent("" + agentLeadSourceId) + "&";
        if (productLineId !== undefined && productLineId !== null)
            url_ += "ProductLineId=" + encodeURIComponent("" + productLineId) + "&";
        if (carrierId !== undefined && carrierId !== null)
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (leadPhaseId !== undefined && leadPhaseId !== null)
            url_ += "LeadPhaseId=" + encodeURIComponent("" + leadPhaseId) + "&";
        if (leadPhaseDetailId !== undefined && leadPhaseDetailId !== null)
            url_ += "LeadPhaseDetailId=" + encodeURIComponent("" + leadPhaseDetailId) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (stage !== undefined && stage !== null)
            url_ += "Stage=" + encodeURIComponent("" + stage) + "&";
        if (isIncludeInactiveCarrier === null)
            throw new Error("The parameter 'isIncludeInactiveCarrier' cannot be null.");
        else if (isIncludeInactiveCarrier !== undefined)
            url_ += "IsIncludeInactiveCarrier=" + encodeURIComponent("" + isIncludeInactiveCarrier) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllMarketerLeads(_response);
        });
    }

    protected processGetAllMarketerLeads(response: Response): Promise<MarketerLeadSearchReponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketerLeadSearchReponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketerLeadSearchReponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createMarketerLead(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateMarketerLeadModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/lead/v{v}/marketerleads";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateMarketerLead(_response);
        });
    }

    protected processCreateMarketerLead(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateMarketerLead(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: UpdateMarkerLeadModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/lead/v{v}/marketerleads";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateMarketerLead(_response);
        });
    }

    protected processUpdateMarketerLead(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getMarketerLeadById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<MarketerLeadModel> {
        let url_ = this.baseUrl + "/api/lead/v{v}/marketerleads/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMarketerLeadById(_response);
        });
    }

    protected processGetMarketerLeadById(response: Response): Promise<MarketerLeadModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketerLeadModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getSubAssigneeLookup(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/lead/v{v}/marketerleads/{id}/subassigneelookup";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSubAssigneeLookup(_response);
        });
    }

    protected processGetSubAssigneeLookup(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param isContracted (optional) 
     * @param isMarketer (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllMarketerLeadsLookup(v: string, isContracted?: boolean | undefined, isMarketer?: boolean | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<MarketerLeadsLookupResponse> {
        let url_ = this.baseUrl + "/api/lead/v{v}/marketerleads/lookup?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (isContracted === null)
            throw new Error("The parameter 'isContracted' cannot be null.");
        else if (isContracted !== undefined)
            url_ += "IsContracted=" + encodeURIComponent("" + isContracted) + "&";
        if (isMarketer === null)
            throw new Error("The parameter 'isMarketer' cannot be null.");
        else if (isMarketer !== undefined)
            url_ += "IsMarketer=" + encodeURIComponent("" + isMarketer) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllMarketerLeadsLookup(_response);
        });
    }

    protected processGetAllMarketerLeadsLookup(response: Response): Promise<MarketerLeadsLookupResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketerLeadsLookupResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketerLeadsLookupResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getLeadPhaseDetails(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/lead/v{v}/marketerleads/{id}/leadphasedetails";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLeadPhaseDetails(_response);
        });
    }

    protected processGetLeadPhaseDetails(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param isReferral (optional) 
     * @param fileType (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllMarketerLeadsExport(v: string, isReferral?: boolean | undefined, fileType?: FileType | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/lead/v{v}/marketerleads/exportLeads?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (isReferral === null)
            throw new Error("The parameter 'isReferral' cannot be null.");
        else if (isReferral !== undefined)
            url_ += "IsReferral=" + encodeURIComponent("" + isReferral) + "&";
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "FileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllMarketerLeadsExport(_response);
        });
    }

    protected processGetAllMarketerLeadsExport(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param fileType (optional) 
     * @param marketerUserId (optional) 
     * @param downline (optional) 
     * @param agentId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getLeadsMonthSummary(v: string, fileType?: FileType | undefined, marketerUserId?: number | null | undefined, downline?: number | null | undefined, agentId?: number | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<MarketerLeadsMonthSummaryResponse> {
        let url_ = this.baseUrl + "/api/lead/v{v}/marketerleads/monthSummary?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "FileType=" + encodeURIComponent("" + fileType) + "&";
        if (marketerUserId !== undefined && marketerUserId !== null)
            url_ += "MarketerUserId=" + encodeURIComponent("" + marketerUserId) + "&";
        if (downline !== undefined && downline !== null)
            url_ += "Downline=" + encodeURIComponent("" + downline) + "&";
        if (agentId !== undefined && agentId !== null)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLeadsMonthSummary(_response);
        });
    }

    protected processGetLeadsMonthSummary(response: Response): Promise<MarketerLeadsMonthSummaryResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketerLeadsMonthSummaryResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketerLeadsMonthSummaryResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getMarketerLeadDetailsById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<MarketerLeadDetailsResponse> {
        let url_ = this.baseUrl + "/api/lead/v{v}/marketerleads/{id}/MarketerLeadDetails";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMarketerLeadDetailsById(_response);
        });
    }

    protected processGetMarketerLeadDetailsById(response: Response): Promise<MarketerLeadDetailsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketerLeadDetailsResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getMarketerLeadNotesById(agentId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<MarketerLeadNotesResponse> {
        let url_ = this.baseUrl + "/api/lead/v{v}/marketerleads/{agentId}/MarketerLeadNotes";
        if (agentId === undefined || agentId === null)
            throw new Error("The parameter 'agentId' must be defined.");
        url_ = url_.replace("{agentId}", encodeURIComponent("" + agentId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMarketerLeadNotesById(_response);
        });
    }

    protected processGetMarketerLeadNotesById(response: Response): Promise<MarketerLeadNotesResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketerLeadNotesResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createMarketerLeadNotes(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateMarketerLeadNotesModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/lead/v{v}/marketerleads/MarketerLeadNotes";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateMarketerLeadNotes(_response);
        });
    }

    protected processCreateMarketerLeadNotes(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    approvePhoneEmail(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: ApproveEmailPhoneModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/lead/v{v}/marketerleads/approvephoneemail";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processApprovePhoneEmail(_response);
        });
    }

    protected processApprovePhoneEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getMarketerLeadPayoutLevelById(companyId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<MarketerLeadPayoutLevelResponse> {
        let url_ = this.baseUrl + "/api/lead/v{v}/marketerleads/{companyId}/MarketerLeadPayoutLevel";
        if (companyId === undefined || companyId === null)
            throw new Error("The parameter 'companyId' must be defined.");
        url_ = url_.replace("{companyId}", encodeURIComponent("" + companyId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetMarketerLeadPayoutLevelById(_response);
        });
    }

    protected processGetMarketerLeadPayoutLevelById(response: Response): Promise<MarketerLeadPayoutLevelResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketerLeadPayoutLevelResponse;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param fileType (optional) 
     * @param marketerUserId (optional) 
     * @param downline (optional) 
     * @param agentId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getContractedLeadsReport(v: string, fileType?: FileType | undefined, marketerUserId?: number | null | undefined, downline?: number | null | undefined, agentId?: number | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/lead/v{v}/reports/contractedleads?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "FileType=" + encodeURIComponent("" + fileType) + "&";
        if (marketerUserId !== undefined && marketerUserId !== null)
            url_ += "MarketerUserId=" + encodeURIComponent("" + marketerUserId) + "&";
        if (downline !== undefined && downline !== null)
            url_ += "Downline=" + encodeURIComponent("" + downline) + "&";
        if (agentId !== undefined && agentId !== null)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetContractedLeadsReport(_response);
        });
    }

    protected processGetContractedLeadsReport(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param fileType (optional) 
     * @param marketerUserId (optional) 
     * @param downline (optional) 
     * @param agentId (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getActivatedLeadsReport(v: string, fileType?: FileType | undefined, marketerUserId?: number | null | undefined, downline?: number | null | undefined, agentId?: number | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/lead/v{v}/reports/activatedleads?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "FileType=" + encodeURIComponent("" + fileType) + "&";
        if (marketerUserId !== undefined && marketerUserId !== null)
            url_ += "MarketerUserId=" + encodeURIComponent("" + marketerUserId) + "&";
        if (downline !== undefined && downline !== null)
            url_ += "Downline=" + encodeURIComponent("" + downline) + "&";
        if (agentId !== undefined && agentId !== null)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetActivatedLeadsReport(_response);
        });
    }

    protected processGetActivatedLeadsReport(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param agentLeadId (optional) 
     * @param agentId (optional) 
     * @param agentLastName (optional) 
     * @param assigneeId (optional) 
     * @param subAssigneeId (optional) 
     * @param agentLeadSourceId (optional) 
     * @param productLineId (optional) 
     * @param carrierId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param leadPhaseId (optional) 
     * @param leadPhaseDetailId (optional) 
     * @param status (optional) 
     * @param stage (optional) 
     * @param isIncludeInactiveCarrier (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllSalesOpsLeads(v: string, agentLeadId?: number | null | undefined, agentId?: number | null | undefined, agentLastName?: string | null | undefined, assigneeId?: number | null | undefined, subAssigneeId?: number | null | undefined, agentLeadSourceId?: number | null | undefined, productLineId?: number | null | undefined, carrierId?: number | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, leadPhaseId?: number | null | undefined, leadPhaseDetailId?: number | null | undefined, status?: number | null | undefined, stage?: number | null | undefined, isIncludeInactiveCarrier?: boolean | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<SalesOpsLeadSearchReponse> {
        let url_ = this.baseUrl + "/api/lead/v{v}/salesopsleads?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (agentLeadId !== undefined && agentLeadId !== null)
            url_ += "AgentLeadId=" + encodeURIComponent("" + agentLeadId) + "&";
        if (agentId !== undefined && agentId !== null)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (agentLastName !== undefined && agentLastName !== null)
            url_ += "AgentLastName=" + encodeURIComponent("" + agentLastName) + "&";
        if (assigneeId !== undefined && assigneeId !== null)
            url_ += "AssigneeId=" + encodeURIComponent("" + assigneeId) + "&";
        if (subAssigneeId !== undefined && subAssigneeId !== null)
            url_ += "SubAssigneeId=" + encodeURIComponent("" + subAssigneeId) + "&";
        if (agentLeadSourceId !== undefined && agentLeadSourceId !== null)
            url_ += "AgentLeadSourceId=" + encodeURIComponent("" + agentLeadSourceId) + "&";
        if (productLineId !== undefined && productLineId !== null)
            url_ += "ProductLineId=" + encodeURIComponent("" + productLineId) + "&";
        if (carrierId !== undefined && carrierId !== null)
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (leadPhaseId !== undefined && leadPhaseId !== null)
            url_ += "LeadPhaseId=" + encodeURIComponent("" + leadPhaseId) + "&";
        if (leadPhaseDetailId !== undefined && leadPhaseDetailId !== null)
            url_ += "LeadPhaseDetailId=" + encodeURIComponent("" + leadPhaseDetailId) + "&";
        if (status !== undefined && status !== null)
            url_ += "Status=" + encodeURIComponent("" + status) + "&";
        if (stage !== undefined && stage !== null)
            url_ += "Stage=" + encodeURIComponent("" + stage) + "&";
        if (isIncludeInactiveCarrier === null)
            throw new Error("The parameter 'isIncludeInactiveCarrier' cannot be null.");
        else if (isIncludeInactiveCarrier !== undefined)
            url_ += "IsIncludeInactiveCarrier=" + encodeURIComponent("" + isIncludeInactiveCarrier) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllSalesOpsLeads(_response);
        });
    }

    protected processGetAllSalesOpsLeads(response: Response): Promise<SalesOpsLeadSearchReponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SalesOpsLeadSearchReponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalesOpsLeadSearchReponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    createSalesOpsLead(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: CreateSalesOpsLeadModel | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/lead/v{v}/salesopsleads";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCreateSalesOpsLead(_response);
        });
    }

    protected processCreateSalesOpsLead(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            result201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result201;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateSalesOpsLead(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: UpdateSalesOpsLeadModel | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/lead/v{v}/salesopsleads";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSalesOpsLead(_response);
        });
    }

    protected processUpdateSalesOpsLead(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getSalesOpsLeadById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<SalesOpsleadUpdateModel> {
        let url_ = this.baseUrl + "/api/lead/v{v}/salesopsleads/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetSalesOpsLeadById(_response);
        });
    }

    protected processGetSalesOpsLeadById(response: Response): Promise<SalesOpsleadUpdateModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SalesOpsleadUpdateModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param fileType (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllSalesOpsLeadsExport(v: string, fileType?: FileType | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/lead/v{v}/salesopsleads/export?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (fileType === null)
            throw new Error("The parameter 'fileType' cannot be null.");
        else if (fileType !== undefined)
            url_ += "FileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllSalesOpsLeadsExport(_response);
        });
    }

    protected processGetAllSalesOpsLeadsExport(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllSalesOpsLeadLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<SalesOpsLeadLookupModel[]> {
        let url_ = this.baseUrl + "/api/lead/v{v}/salesopsleads/lookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllSalesOpsLeadLookup(_response);
        });
    }

    protected processGetAllSalesOpsLeadLookup(response: Response): Promise<SalesOpsLeadLookupModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SalesOpsLeadLookupModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalesOpsLeadLookupModel[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getLeadPhase(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/lead/v{v}/salesopsleads/{id}/leadphase";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetLeadPhase(_response);
        });
    }

    protected processGetLeadPhase(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param leadId (optional) 
     * @param startDate (optional) 
     * @param endDate (optional) 
     * @param leadPhaseId (optional) 
     * @param leadPhaseDetailId (optional) 
     * @param agentLeadSourceId (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllSalesOpsUnmatchedLeads(v: string, leadId?: number | null | undefined, startDate?: Date | null | undefined, endDate?: Date | null | undefined, leadPhaseId?: number | null | undefined, leadPhaseDetailId?: number | null | undefined, agentLeadSourceId?: number | null | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<SalesOpsUnmatchedLeadResponse> {
        let url_ = this.baseUrl + "/api/lead/v{v}/salesopsunmatchedleads?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (leadId !== undefined && leadId !== null)
            url_ += "LeadId=" + encodeURIComponent("" + leadId) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (leadPhaseId !== undefined && leadPhaseId !== null)
            url_ += "LeadPhaseId=" + encodeURIComponent("" + leadPhaseId) + "&";
        if (leadPhaseDetailId !== undefined && leadPhaseDetailId !== null)
            url_ += "LeadPhaseDetailId=" + encodeURIComponent("" + leadPhaseDetailId) + "&";
        if (agentLeadSourceId !== undefined && agentLeadSourceId !== null)
            url_ += "AgentLeadSourceId=" + encodeURIComponent("" + agentLeadSourceId) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllSalesOpsUnmatchedLeads(_response);
        });
    }

    protected processGetAllSalesOpsUnmatchedLeads(response: Response): Promise<SalesOpsUnmatchedLeadResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SalesOpsUnmatchedLeadResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalesOpsUnmatchedLeadResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @param body (optional) 
     * @return Success
     */
    updateSalesOpsUnmatchedLead(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: UnMatchedLeadModel[] | null | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/lead/v{v}/salesopsunmatchedleads";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processUpdateSalesOpsUnmatchedLead(_response);
        });
    }

    protected processUpdateSalesOpsUnmatchedLead(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getAllSalesOpsUnmatchedLookup(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<SalesOpsUnmatchedLookUpModel> {
        let url_ = this.baseUrl + "/api/lead/v{v}/salesopsunmatchedleads/lookup";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllSalesOpsUnmatchedLookup(_response);
        });
    }

    protected processGetAllSalesOpsUnmatchedLookup(response: Response): Promise<SalesOpsUnmatchedLookUpModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SalesOpsUnmatchedLookUpModel;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SalesOpsUnmatchedLookUpModel>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) localhost:3000
     * @return Success
     */
    getUnmatchedLeadDetailById(id: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<UnMatchedLeadDetailModel> {
        let url_ = this.baseUrl + "/api/lead/v{v}/salesopsunmatchedleads/{id}/details";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetUnmatchedLeadDetailById(_response);
        });
    }

    protected processGetUnmatchedLeadDetailById(response: Response): Promise<UnMatchedLeadDetailModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnMatchedLeadDetailModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }
}

export interface AgentLeadDisabledCarriersListModel {
    id?: number;
    companyName?: string | undefined;
}

export interface AgentLeadDisabledCarriersSearchResponse {
    recordCount?: number;
    emailAllRecords?: AgentLeadDisabledCarriersListModel[] | undefined;
    data?: AgentLeadDisabledCarriersListModel[] | undefined;
}

export interface AgentLeadDisabledCarrierModel {
    carrierId?: number;
    companyName?: string | undefined;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export interface ListItem {
    value?: string | undefined;
    text?: string | undefined;
    selected?: boolean;
}

export interface MarkerterLeadListModel {
    agentLeadId?: number;
    agentId?: number | undefined;
    leadAgent?: string | undefined;
    leadAgentLastName?: string | undefined;
    leadAgentFirstName?: string | undefined;
    assigneeId?: number | undefined;
    assignee?: string | undefined;
    assigneeFirstName?: string | undefined;
    assigneeLastName?: string | undefined;
    subAssigneeId?: number | undefined;
    subAssignee?: string | undefined;
    assignerId?: number | undefined;
    agentLeadSourceId?: number | undefined;
    productLineId?: number | undefined;
    productLine?: string | undefined;
    carrierId?: number | undefined;
    carrier?: string | undefined;
    leadPhaseId?: number;
    leadPhase?: string | undefined;
    leadPhaseDetailId?: number;
    leadPhaseDetail?: string | undefined;
    dateCreated?: Date;
    dateFollowUp?: Date | undefined;
    leadSourceName?: string | undefined;
    subAssigneeFirstName?: string | undefined;
    subAssigneeLastName?: string | undefined;
    displayDateCreated?: Date;
    displayDateFollowUp?: Date | undefined;
    isHidden?: boolean;
}

export interface MarketerLeadSearchReponse {
    recordCount?: number;
    emailAllRecords?: MarkerterLeadListModel[] | undefined;
    data?: MarkerterLeadListModel[] | undefined;
}

export interface CreateMarketerLeadModel {
    id?: number;
    agentId?: number;
    assigneeId?: number | undefined;
    subAssigneeId?: number;
    productLineId?: number | undefined;
    carrierId?: number;
    leadSourceId?: number;
    leadNote?: string | undefined;
    productLineActivated?: boolean;
    assignerId?: number;
    createdUserId?: number;
    dateCreated?: Date;
    dateAssigned?: Date | undefined;
    recruiterName?: string | undefined;
}

export interface UpdateMarkerLeadModel {
    agentLeadId?: number;
    subAssigneeId?: number | undefined;
    dateFollowUp?: Date | undefined;
    leadPhaseId?: number;
    leadPhaseDetailId?: number;
    isClosed?: boolean;
    isContracted?: boolean;
    isContractingSent?: boolean;
}

export interface ProductLineModel {
    id?: number;
    productLineName?: string | undefined;
    isMarketerHeriarchyBased?: boolean;
}

export interface MarketerLeadModel {
    assinee?: ListItem[] | undefined;
    subAssingee?: ListItem[] | undefined;
    leadSource?: ListItem[] | undefined;
    carrier?: ListItem[] | undefined;
    leadPhase?: ListItem[] | undefined;
    leadPhaseDetail?: ListItem[] | undefined;
    productLineModel?: ProductLineModel[] | undefined;
    agentLeadId?: number;
    subAssigneeId?: number | undefined;
    assigneeId?: number | undefined;
    leadPhaseId?: number;
    leadPhaseDetailsId?: number;
    dateFollowUp?: Date | undefined;
}

export interface ProductLineModel2 {
    id?: number;
    productLineName?: string | undefined;
    isMarketerHeriarchyBased?: boolean;
}

export interface MarketerLeadsLookupResponse {
    assignee?: ListItem[] | undefined;
    subAssignee?: ListItem[] | undefined;
    productLine?: ProductLineModel2[] | undefined;
    leadSource?: ListItem[] | undefined;
    carriers?: ListItem[] | undefined;
    referralCount?: number;
    downlineCount?: number;
}

export enum FileType {
    _0 = 0,
    _1 = 1,
}

export interface ReportFile {
    title?: string | undefined;
    data?: string | undefined;
    contentType?: string | undefined;
    fileName?: string | undefined;
}

export interface MonthCount {
    name?: string | undefined;
    count?: number;
    month?: number;
    year?: number;
}

export interface MarketerLeadsMonthSummaryResponse {
    userMonthlyContractedCount?: MonthCount[] | undefined;
    userMonthlyActivatedCount?: MonthCount[] | undefined;
    teamMonthlyContractedCount?: MonthCount[] | undefined;
    teamMonthlyActivatedCount?: MonthCount[] | undefined;
}

export interface UplineHierarchy {
    agentId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export interface MarketerLeadDetailsResponse {
    leadId?: number;
    leadPhaseId?: number;
    agentId?: number | undefined;
    agentName?: string | undefined;
    leadSource?: string | undefined;
    leadSourceDetail?: string | undefined;
    leadSourceDetailLink?: string | undefined;
    agentContactId?: number | undefined;
    agentPhone?: string | undefined;
    agentEmail?: string | undefined;
    leadName?: string | undefined;
    leadPhone?: string | undefined;
    leadEmail?: string | undefined;
    canApprovePhone?: boolean;
    canApproveEmail?: boolean;
    recruiterName?: string | undefined;
    recruiterPhone?: string | undefined;
    recruiterEmail?: string | undefined;
    alternativeContact?: string | undefined;
    leadNote?: string | undefined;
    agentTimeZone?: string | undefined;
    productLineActivated?: string | undefined;
    leadNPN?: string | undefined;
    businessUnit?: string | undefined;
    targetCarrier?: string | undefined;
    productContracted?: string | undefined;
    uplineHierarchy?: UplineHierarchy[] | undefined;
}

export interface MarketerLeadNotesResponse {
    agentNoteId?: number;
    userName?: string | undefined;
    noteCreatedDate?: Date;
    noteText?: string | undefined;
}

export interface CreateMarketerLeadNotesModel {
    agentId?: number;
    note?: string | undefined;
    contractingCompanyId?: number | undefined;
    payoutLevelId?: number | undefined;
    private?: boolean;
    agentLeadId?: number;
    sendNoteEmail?: boolean;
}

export interface ApproveEmailPhoneModel {
    id?: number;
    default?: boolean;
    contactTypeId?: number;
    contactValue?: string | undefined;
    description?: string | undefined;
    agentId?: number;
    createdByUserId?: number;
    dateCreated?: Date;
}

export interface MarketerLeadPayoutLevelResponse {
    payoutLevelId?: number;
    payoutLevelName?: string | undefined;
}

export interface LeadModel {
    agentLeadId?: number;
    agentId?: number | undefined;
    leadAgent?: string | undefined;
    assigneeId?: number | undefined;
    assignee?: string | undefined;
    subAssigneeId?: number | undefined;
    subAssignee?: string | undefined;
    agentLeadSourceId?: number;
    agentLeadSource?: string | undefined;
    assignerId?: number | undefined;
    productLineId?: number | undefined;
    productLine?: string | undefined;
    carrierId?: number | undefined;
    carrier?: string | undefined;
    leadPhaseId?: number | undefined;
    leadPhase?: string | undefined;
    leadPhaseDetailId?: number | undefined;
    leadPhaseDetail?: string | undefined;
    dateCreated?: Date;
    dateFollowUp?: Date | undefined;
    leadPhone?: string | undefined;
    leadEmail?: string | undefined;
    leadNote?: string | undefined;
    leadNPN?: string | undefined;
    leadName?: string | undefined;
    targetCarrier?: string | undefined;
    unverifiedLeadPhone?: string | undefined;
    unverifiedLeadEmail?: string | undefined;
    stage?: string | undefined;
    isHidden?: boolean;
}

export interface SalesOpsLeadSearchReponse {
    recordCount?: number;
    emailAllRecords?: LeadModel[] | undefined;
    data?: LeadModel[] | undefined;
}

export interface CreateSalesOpsLeadModel {
    productLineId?: number;
    carrierId?: number | undefined;
    assignerId?: number;
    assigneeId?: number | undefined;
    subAssigneeId?: number | undefined;
    agentId?: number;
    agentLeadSourceId?: number;
    leadNote?: string | undefined;
    dateAssigned?: Date | undefined;
}

export interface UpdateSalesOpsLeadModel {
    agentLeadId?: number;
    productLineId?: number | undefined;
    assigneeId?: number | undefined;
    subAssigneeId?: number | undefined;
    assignerId?: number | undefined;
    agentId?: number | undefined;
    carrierId?: number | undefined;
    dateAssigned?: Date | undefined;
    dateFollowUp?: Date | undefined;
    leadPhaseId?: number;
    leadPhaseDetailId?: number;
    leadEmails?: string[] | undefined;
    leadPhoneNumbers?: string[] | undefined;
    leadNPN?: string | undefined;
    leadNote?: string | undefined;
    isClosed?: boolean;
    isPreContracted?: boolean;
    invalidReferral?: boolean;
    invalidForActivation?: boolean;
}

export interface SalesOpsleadUpdateModel {
    agentLeadId?: number;
    agentId?: number | undefined;
    agent?: string | undefined;
    assigneeId?: number | undefined;
    subAssigneeId?: number | undefined;
    assignerId?: number | undefined;
    productLineId?: number | undefined;
    carrierId?: number | undefined;
    leadPhaseId?: number | undefined;
    leadPhaseDetailId?: number | undefined;
    dateFollowUp?: Date | undefined;
    agentLeadSourceId?: number;
    agentLeadSourceDetailId?: number | undefined;
    leadSource?: string | undefined;
    leadSourceDetail?: string | undefined;
    leadSourceDetailLink?: string | undefined;
    agentContactId?: number | undefined;
    agentPhone?: string | undefined;
    agentEmail?: string | undefined;
    leadPhone?: string[] | undefined;
    leadEmail?: string[] | undefined;
    recruiterName?: string | undefined;
    recruiterPhone?: string | undefined;
    recruiterEmail?: string | undefined;
    leadNote?: string | undefined;
    businessUnit?: string | undefined;
    targetCarrier?: string | undefined;
    leadName?: string | undefined;
    leadNPN?: string | undefined;
    alternativeContact?: string | undefined;
    unverifiedLeadPhone?: string | undefined;
    unverifiedLeadEmail?: string | undefined;
    invalidReferral?: boolean;
    isPreContracted?: boolean;
    productContracted?: string | undefined;
}

export interface ProductLineModel3 {
    id?: number;
    productLineName?: string | undefined;
    isMarketerHeriarchyBased?: boolean;
}

export interface SalesOpsLeadLookupModel {
    assignee?: ListItem[] | undefined;
    subAssignee?: ListItem[] | undefined;
    carrier?: ListItem[] | undefined;
    leadPhase?: ListItem[] | undefined;
    leadSource?: ListItem[] | undefined;
    productLines?: ProductLineModel3[] | undefined;
}

export interface SalesOpsUnmatchedLeadResponse {
    recordCount?: number;
    emailAllRecords?: LeadModel[] | undefined;
    data?: LeadModel[] | undefined;
}

export interface UnMatchedLeadModel {
    agentLeadId?: number;
    productLineId?: number | undefined;
    assigneeId?: number | undefined;
    subAssigneeId?: number | undefined;
    agentId?: number | undefined;
    dateAssigned?: Date | undefined;
    dateFollowUp?: Date | undefined;
    leadPhaseId?: number;
    leadPhaseDetailId?: number;
    leadEmails?: string[] | undefined;
    leadPhoneNumbers?: string[] | undefined;
    leadNPN?: string | undefined;
    leadNote?: string | undefined;
    isClosed?: boolean;
}

export interface ProductLineModel4 {
    id?: number;
    productLineName?: string | undefined;
    isMarketerHeriarchyBased?: boolean;
}

export interface SalesOpsUnmatchedLookUpModel {
    assignee?: ListItem[] | undefined;
    subAssignee?: ListItem[] | undefined;
    productLine?: ProductLineModel4[] | undefined;
    leadSource?: ListItem[] | undefined;
}

export interface UnMatchedLeadDetailModel {
    agentLeadId?: number;
    agentId?: number | undefined;
    agent?: string | undefined;
    assigneeId?: number | undefined;
    subAssigneeId?: number | undefined;
    assignerId?: number | undefined;
    productLineId?: number | undefined;
    carrierId?: number | undefined;
    leadPhaseId?: number | undefined;
    leadPhaseDetailId?: number | undefined;
    dateFollowUp?: Date | undefined;
    agentLeadSourceId?: number;
    agentLeadSourceDetailId?: number | undefined;
    leadSource?: string | undefined;
    leadSourceDetail?: string | undefined;
    leadSourceDetailLink?: string | undefined;
    agentContactId?: number | undefined;
    agentPhone?: string | undefined;
    agentEmail?: string | undefined;
    leadPhone?: string[] | undefined;
    leadEmail?: string[] | undefined;
    recruiterName?: string | undefined;
    recruiterPhone?: string | undefined;
    recruiterEmail?: string | undefined;
    leadNote?: string | undefined;
    businessUnit?: string | undefined;
    targetCarrier?: string | undefined;
    leadName?: string | undefined;
    leadNPN?: string | undefined;
    alternativeContact?: string | undefined;
    unverifiedLeadPhone?: string[] | undefined;
    unverifiedLeadEmail?: string[] | undefined;
    invalidReferral?: boolean;
    isPreContracted?: boolean;
    productContracted?: string | undefined;
    leadNationalProducerNumber?: string | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}